class ModuloEnum {
    constructor(cod) {
        this.cod = cod;
    }

    static fromcod(cod) {
        return Object.values(ModuloEnum).find(status => status.cod === cod);
    }

}


ModuloEnum.COMPRAS = new ModuloEnum(1);
ModuloEnum.LICITACAO = new ModuloEnum(2);
ModuloEnum.ALMOXARIFADO = new ModuloEnum(3);
ModuloEnum.PATRIMONIO = new ModuloEnum(4);
ModuloEnum.DIARIAS = new ModuloEnum(8);
ModuloEnum.FROTAS = new ModuloEnum(7);
ModuloEnum.ESTAGIARIOBOLSISTA = new ModuloEnum(9);
ModuloEnum.NAO_NECESSITA_VERIFICACAO = new ModuloEnum(10);

export default ModuloEnum;